type EnvSource = Record<string, unknown>;

const env: EnvSource = import.meta.env as unknown as EnvSource;

function getEnvString(key: string): string | undefined {
  const value = env[key];
  if (value == null) return undefined;
  if (typeof value === "string") return value;
  // Vite exposes all values as strings; this is a narrow safeguard
  return String(value);
}

function requireEnvString(key: string): string {
  const value = getEnvString(key);
  if (value == null || value.length === 0) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const ENV = {
  LOG_LEVEL: requireEnvString("VITE_LOG_LEVEL"),
  ENABLE_LOGGING: requireEnvString("VITE_ENABLE_LOGGING"),

  ENVIRONMENT: requireEnvString("VITE_ENVIRONMENT"),
  ZEOS_API_KEY: requireEnvString("VITE_ZEOS_API_KEY"),
  ZEOS_API_URL: requireEnvString("VITE_ZEOS_API_URL"),
  ZEOS_API_VERSION: requireEnvString("VITE_ZEOS_API_VERSION"),

  EMAIL_DOMAINS: requireEnvString("VITE_EMAIL_DOMAINS"),
  EMAIL_ALLOWLIST: getEnvString("VITE_EMAIL_ALLOWLIST"),

  DEMO_ONBOARD_EMAIL: requireEnvString("VITE_DEMO_ONBD_EMAIL"),
  DEMO_ONBOARD_PASSWORD: requireEnvString("VITE_DEMO_ONBD_PW"),

  FIREBASE_API_KEY: requireEnvString("VITE_FIREBASE_API_KEY"),
  FIREBASE_AUTH_DOMAIN: requireEnvString("VITE_FIREBASE_AUTH_DOMAIN"),
  FIREBASE_PROJECT_ID: requireEnvString("VITE_FIREBASE_PROJECT_ID"),
  FIREBASE_STORAGE_BUCKET: requireEnvString("VITE_FIREBASE_STORAGE_BUCKET"),
  FIREBASE_MESSAGING_SENDER_ID: requireEnvString(
    "VITE_FIREBASE_MESSAGING_SENDER_ID"
  ),
  FIREBASE_APP_ID: requireEnvString("VITE_FIREBASE_APP_ID"),
  // FIREBASE_MEASUREMENT_ID: requireEnvString("VITE_FIREBASE_MEASUREMENT_ID"),

  POSTHOG_KEY: getEnvString("VITE_POSTHOG_KEY"),
  POSTHOG_HOST:
    getEnvString("VITE_POSTHOG_HOST") ?? "https://us.i.posthog.com",
  // 0..1 share of page loads that record a session; unset/0 disables replay.
  POSTHOG_REPLAY_SAMPLE_RATE: getEnvString("VITE_POSTHOG_REPLAY_SAMPLE_RATE"),

  GOOGLE_MAPS_API_KEY: requireEnvString("VITE_GOOGLE_MAPS_API_KEY"),

  BAYOU_COMPANY_ID: requireEnvString("VITE_BAYOU_COMPANY_ID"),
  BAYOU_ENVIRONMENT: requireEnvString("VITE_BAYOU_ENVIRONMENT"),
  CARBON_CLEAR_BASE_URL: requireEnvString("VITE_CARBON_CLEAR_BASE_URL"),
} as const;

export type EnvKey = keyof typeof ENV;
